import { Badge, Button } from "react-bootstrap";
import variables from "../../../styles/utils.module.scss";
import img1 from "../../../images/mockups/1.jpg";
import { AWS_S3_BASE_URL } from "../../../helpers/utility";
import style from "../../../styles/locationSummary.module.scss";
import SuitabilitySummary from '../../../components/SuitabilitySummary';
import { TYPE_OF_CARE } from '../../../helpers/constants';

export default function LocationCard({ location, openEnquiryModal }) {
  return (
    <div
      key={location.key}
      style={{
        display: "flex",
        flexDirection: "row",
        flexGrow: 1,
        borderBottom: "1px solid #dcdcdc",
        margin: "0px 0px 10px",
        backgroundColor: variables.pureWhite,
        borderRadius: "6px",
      }}
    >
      <div
        style={{
          backgroundImage: location.galleryURLs
            ? `url(${`${AWS_S3_BASE_URL}/${
                location.galleryURLs[parseInt(location.galleryURLs?.length * Math.random())]
                  .externalId
              }`})`
            : `url(${img1})`,
          marginRight: 15,
          width: 250,
          maxWidth: "33%",
          borderTopLeftRadius: "6px",
          borderBottomLeftRadius: "6px",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          flexGrow: 1,
          padding: "15px 10px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flexGrow: 1,
          }}
        >
          <h1 className={"h3"} style={{ fontWeight: "bold", marginBottom: 0 }}>
            {location.name}
          </h1>
          <div style={{ fontSize: 12, color: variables.darkGrey, marginTop: 5 }}>
            Distance: {location.distance} miles | {location.address?.addressLine1},{" "}
            {location.address?.postcode}
          </div>
          <div className="mt-2">
            {location.ofstedReport?.isClosed ? (
              <Badge bg="danger" className={style.badgeSpace}>
                Closed
              </Badge>
            ) : null}

            {location.ofstedReport?.URN ? (
              <Badge bg="secondary" className={style.badgeSpace}>
                Regulated
              </Badge>
            ) : null}

            {location.ofstedReport?.inspections?.length > 0 ? (
              <Badge
                bg="secondary"
                title={location.ofstedReport?.inspections[0]?.name}
                className={style.badgeSpace}
              >
                <a
                  href={location.ofstedReport?.inspections[0]?.link}
                  target="_blank"
                  style={{ color: variables.white }}
                >
                  Inspected
                  <i
                    className={`bi bi-link-45deg`}
                    style={{
                      fontSize: "12px",
                      marginLeft: "6px",
                      overflowY: "hidden",
                      lineHeight: "10px",
                      height: "10px",
                      display: "inline-block",
                      color: variables.white,
                    }}
                  ></i>
                </a>
              </Badge>
            ) : null}

            <Badge bg="secondary" className={style.badgeSpace}>
              {location.staffCount} Staff
            </Badge>

            {location.typeOfCare?.length > 0 ? (
              <Badge bg="secondary" className={style.badgeSpace}>
                {location.typeOfCare.map((type) => TYPE_OF_CARE[type])}
              </Badge>
            ) : null}

            {location.capacityMax - location.capacityUsed < 5 ? (
              <Badge bg="secondary" className={style.badgeSpace}>
                Limited Availability
              </Badge>
            ) : null}
          </div>
          {location.match ? (
            <SuitabilitySummary match={location.match} wrapperStyle={{ marginTop: 5 }} />
          ) : null}
        </div>

        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            flexBasis: 45,
          }}
        >
          <Button
            onClick={() => {
              if (typeof openEnquiryModal === "function") {
                openEnquiryModal(location);
              } else {
                console.error(`ERROR: missing openModal`);
              }
            }}
          >
            ENQUIRE
          </Button>
        </div>
      </div>
    </div>
  );
}
